import { render, staticRenderFns } from "./MoOfficialNav.vue?vue&type=template&id=9f9a6edc&"
import script from "./MoOfficialNav.vue?vue&type=script&lang=ts&"
export * from "./MoOfficialNav.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports